import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/3.mp3"
export default function P1() {
    return (
        <MainLayout
            title="Wiatrak"
            question="Którą drogę do miasteczka wybierzesz?"
            audio={audio}
            answers={{
                ans1: "Szutrową drogę.",
                ans2: "Ścieżkę pod lasem.",
            }}
            links={{
                link1: PAGES.p5,
                link2: PAGES.p6,
            }}
            content={
                <div>
                    <p>
                        Idąc w stronę wiatraka, z daleka słyszysz skrzypienie belek i szorowanie młyńskich kół, które po chwili zaczynają brzmieć jak melodia. Wokół widzisz małe zbiegowisko.
                    </p>
                    <ul>
                        <li>Koźlaka chcą burzyć?</li>
                        <li>Holenderskie wiatraki lepsze!</li>
                        <li>Może lepsze, może gorsze…. Czas pokaże…</li>
                        <li>Dzień dobry, gdzie się tu można zatrzymać? Ktoś szuka do pracy? – pytasz nieśmiało.</li>
                        <li>Pracy niby zawsze dużo, ale u mnie nie potrzeba pomocy…</li>
                        <li>Ty, a u szewca? No, u Mietka?</li>
                        <li>Kantor będzie wiedział. Pastor wyjechał…</li>
                        <li>Tak, tak, tak, kantor pomoże, to nawet lepiej… Tam w miasteczku, w kantoracie. Ho, ho, człowiek zacnie uczony, na pewno coś poradzi.</li>
                    </ul>
                    <p>
                        Ludzie pod wiatrakiem zaczynają ci się coraz dokładniej przyglądać. Dziękujesz więc za wskazówki i decydujesz, że czas ruszać dalej. Ale którędy? Głupio pytać ich jeszcze raz. Szutrowa droga prowadzi prosto do miasteczka, ale od strony krętej ścieżki wzdłuż świerkowego lasu słychać dziwne odgłosy.
                    </p>
                </div>
            }
        />

    );
}